<app-sell-orders-table-header (filterValues)="onFiltersApply($event)"></app-sell-orders-table-header>
<app-table-items>
  <app-table-item *ngFor="let sellOrder of sellOrders; let odd = odd" [isOdd]="odd" class="item">
    <app-table-column name="number" size="medium" (click)="itemClicked(sellOrder)">
      <span content>{{ sellOrder.no || '---' }}</span>
    </app-table-column>

    <app-table-column name="receivedAt" size="small" (click)="itemClicked(sellOrder)">
      <span content>{{ formatDate(sellOrder.date) }}</span>
    </app-table-column>

    <app-table-column name="exitAt" size="small" (click)="itemClicked(sellOrder)">
      <span content>{{ formatDate(sellOrder.outOrderEventHistoryDispatchedAt) }}</span>
    </app-table-column>

    <app-table-column name="description" size="medium" (click)="itemClicked(sellOrder)">
      <span content>
        <span *ngFor="let product of sellOrder.skuGroups">{{ product.productName || '---' }}</span>
        <span *ngIf="!sellOrder.skuGroups || sellOrder.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="quantity" size="qtd" alignRight="true" (click)="itemClicked(sellOrder)">
      <span content>
        <span *ngFor="let product of sellOrder.skuGroups">{{ product.quantity * product.packSize || '---' }}</span>
        <span *ngIf="!sellOrder.skuGroups || sellOrder.skuGroups.length === 0">---</span>
      </span>
    </app-table-column>

    <app-table-column name="messages" size="smallest" alignRight="true" (click)="itemClicked(sellOrder, 'messages')">
      <span content>
        <i *ngIf="!sellOrder.commentsQty" class="uil uil-comment"></i>
        <i *ngIf="sellOrder.commentsQty" class="uil uil-comment-lines"></i>
        {{ sellOrder.commentsQty | number:'1.0-0':'pt-BR' }}
      </span>
    </app-table-column>
  </app-table-item>
</app-table-items>
